import {
  route,
} from '@app/Routing/helpers'
import { accessPermission } from '@access/permissions'

import {
  ALL,
} from '@app/Seller/accessTokens'

const ReviewsBase = () => import('@app/Seller/Components/Base')

const ProductReviewList = () => import('@app/Seller/Review/ProductList')
const OrderReviewList = () => import('@app/Seller/Review/OrderList')

const MODEL = 'reviews'

const BASE = `${MODEL}/`
// const u = url => BASE + url

const PRODUCTS_LIST = 'products/'
const ORDER_LIST = 'orders/'

export const REVIEW_PREFIX = `${MODEL}:`
const p = name => REVIEW_PREFIX + name

export const REVIEW_BASE_NAME = p('base')
export const PRODUCT_REVIEW_VIEW_NAME = p('product')
export const ORDER_REVIEW_VIEW_NAME = p('order')

// ?unanswered=1 opens a reviews list filtered to reviews without an answer.
export const REVIEW_UNANSWERED_QUERY_KEY = 'unanswered'

export function createRoutes(options) {
  return [
    route(BASE, ReviewsBase, REVIEW_BASE_NAME, {
      meta: accessPermission(ALL, options),
      redirect: { name: PRODUCT_REVIEW_VIEW_NAME },
      children: [
        route(PRODUCTS_LIST, ProductReviewList, PRODUCT_REVIEW_VIEW_NAME, {
          meta: accessPermission(ALL, options),
        }),
        route(ORDER_LIST, OrderReviewList, ORDER_REVIEW_VIEW_NAME, {
          meta: accessPermission(ALL, options),
        }),
      ],
    }),
  ]
}
